// src/utils/getPublicId.js
const getPublicId = (img) => {
    if (!img) return null;

    // Trường hợp mới: chỉ có public_id (string hoặc object chỉ có public_id)
    if (typeof img === 'string') return img;
    if (img.public_id) return img.public_id;

    // Dự phòng cực hiếm: extract từ url cũ
    if (img.url) {
        const match = img.url.match(/upload\/v\d+\/(.+)/) || img.url.match(/upload\/(.+)/);
        return match ? match[1] : null;
    }

    return null;
};

export default getPublicId;